const state = {
  onMessageBoard: true,
  onCalendar: false,
  onReview: false,
  onUpload: false,
  onProfileCal: false,
};

const mutations = {
  setMessageBoard(state) {
    state.onMessageBoard = true;
    state.onCalendar = false;
    state.onReview = false;
    state.onUpload = false;
    state.onProfileCal = false;
  },
  setCalendar(state) {
    state.onMessageBoard = false;
    state.onCalendar = true;
    state.onReview = false;
    state.onUpload = false;
    state.onProfileCal = false;
  },
  setReview(state) {
    state.onMessageBoard = false;
    state.onCalendar = false;
    state.onReview = true;
    state.onUpload = false;
    state.onProfileCal = false;
  },
  setUpload(state) {
    state.onMessageBoard = false;
    state.onCalendar = false;
    state.onReview = false;
    state.onUpload = true;
    state.onProfileCal = false;
  },
  setProfileCalendar(state) {
    state.onMessageBoard = false;
    state.onCalendar = false;
    state.onReview = false;
    state.onUpload = false;
    state.onProfileCal = true;
  },
};

export default {
  methods: {
    reset() {
      state.onMessageBoard = false;
      state.onCalendar = false;
      state.onReview = false;
      state.onUpload = false;
      state.onProfileCal = false;
    },
  },

  namespaced: true,
  state,
  mutations,
};
